import { Box, Drawer } from '@mui/material';
import { DynamicComponent } from '../DynamicComponent';

export const OverlayDrawer = ({
  open = false,
  component = null,
  close = () => {},
  props = null,
  allowClickOutsideClose = false,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' && !allowClickOutsideClose) return;
        close(event);
      }}
      variant="temporary"
      slotProps={{
        backdrop: {
          style: { backgroundColor: 'transparent', opacity: 0 },
        },
      }}
      PaperProps={{
        sx: {
          width: '350px',
        },
      }}
    >
      <Box
        sx={{ width: '100%', height: '100%', p: 2 }}
        role="presentation"
      >
        {open && component && (
          <DynamicComponent
            is={component}
            close={close}
            {...props}
          />
        )}
      </Box>
    </Drawer>
  );
};
